import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import Swiper from 'swiper';
import 'swiper/swiper-bundle.css';

document.addEventListener('DOMContentLoaded', function () {
  const swiper = new Swiper('.featuresSwiper', {
    modules: [Autoplay, Pagination],
    loop: true,
    spaceBetween: 12,
    initialSlide: 0,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    pagination: {
      el: '.features-swiper-pagination',
      type: 'bullets',
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 16,
        centeredSlides: false,
      },
      1440: {
        slidesPerView: 5,
        spaceBetween: 20,
        centeredSlides: false,
      },
    },
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const swiper = new Swiper('.screenshotsSwiper', {
    modules: [Autoplay, Pagination],
    loop: true,
    spaceBetween: 12,
    initialSlide: 0,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    pagination: {
      el: '.screenshots-swiper-pagination',
      type: 'bullets',
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 16,
        centeredSlides: false,
      },
      1440: {
        slidesPerView: 3,
        spaceBetween: 40,
        centeredSlides: false,
      },
    },
  });
});
